import { PageBlock, Stack, Box, Heading } from 'braid-design-system';
import { Fragment, type ReactNode } from 'react';

import Header from 'src/components/Header/Header';

import Disclaimer from '../Disclaimer/Disclaimer';

interface PriceGuideContainerProps {
  children: ReactNode;
}

export const PriceGuideContainer = (props: PriceGuideContainerProps) => (
  <Fragment>
    <Header title="Sell your business" />

    <PageBlock width="medium">
      <Box marginY="large">
        <Stack space="large">
          <Heading level="2" component="h1">
            Price guide
          </Heading>

          <Box>{props.children}</Box>

          <Disclaimer />
        </Stack>
      </Box>
    </PageBlock>
  </Fragment>
);
